// Properties in API response.
export const API_CREATED = "CREATED";
export const API_LAST_MODIFIED = "LASTMODIFIED";
export const API_COVER_POLICY_FIN = "WCD_COVERPOLICYINLANGUAGE1";
export const API_COVER_POLICY_ENG = "WCD_COVERPOLICYINLANGUAGE2";
export const API_CLASS_FIN = "WCD_GRNTCLASSINLANGUAGE1";
export const API_CLASS_ENG = "WCD_GRNTCLASSINLANGUAGE2";
export const API_RISK_CLASS = "WCD_RISKCLASS";
export const API_BANK_SPECIALIST = "WCT_BANKSPECIALIST";
export const API_BANK_SPECIALIST_EMAIL = "WCT_BANKSPECIALISTEMAIL";
export const API_BANK_SPECIALIST_PHONE = "WCT_BANKSPECIALISTTEL";
export const API_COUNTRY_SPECIALIST = "WCT_COUNTRYSPECIALIST";
export const API_COUNTRY_SPECIALIST_EMAIL = "WCT_COUNTRYSPECIALISTEMAIL";
export const API_COUNTRY_SPECIALIST_PHONE = "WCT_COUNTRYSPECIALISTTEL";
export const API_NAME_FIN = "WCT_NAMEINLANGUAGE1";
export const API_NAME_ENG = "WCT_NAMEINLANGUAGE2";
export const API_NAME_SWE = "WCT_NAMEINLANGUAGE3";
export const API_RISK_AREA = "WCT_RISKAREA";
export const API_RISK_AREA_NAME_FIN = "WCT_RISKAREANAMEINLNG1";
export const API_RISK_AREA_NAME_ENG = "WCT_RISKAREANAMEINLNG2";
export const API_ENTITY_CREATED_AT = "entity_created";
export const API_COUNTRY_ID = "WCT_COUNTRY";

// Properties used in processed data.
export const CREATED_AT = "createdAt";
export const LAST_MODIFIED = "lastModified";
export const COVER_POLICY_FIN = "coverPolicyFin";
export const COVER_POLICY_ENG = "coverPolicyEng";
export const CLASS_FIN = "classFin";
export const CLASS_ENG = "classEng";
export const RISK_CLASS = "riskClass";
export const BANK_SPECIALIST = "bankSpecialist";
export const BANK_SPECIALIST_EMAIL = "bankSpecialistEmail";
export const BANK_SPECIALIST_PHONE = "bankSpecialistPhone";
export const COUNTRY_SPECIALIST = "countrySpecialist";
export const COUNTRY_SPECIALIST_EMAIL = "countrySpecialistEmail";
export const COUNTRY_SPECIALIST_PHONE = "countrySpecialistPhone";
export const NAME_FIN = "nameFin";
export const NAME_ENG = "nameEng";
export const NAME_SWE = "nameSwe";
export const RISK_AREA = "riskArea";
export const RISK_AREA_NAME_FIN = "riskAreaNameFin";
export const RISK_AREA_NAME_ENG = "riskAreaNameEng";
export const ENTITY_CREATED_AT = "entityCreatedAt";
export const COUNTRY_ID = "countryId";